<div class="sidebar" role="navigation">
  <div class="sidebar-nav navbar-collapse">
    <ul class="nav flex-column" id="side-menu">
      <li *ngFor="let page of pages">
        <a *ngIf="page.route && page.canActivate; else elseBlock" style="text-decoration: none;" [routerLink]="[page.route]"
           routerLinkActive="active">
          {{ page.name }}
        </a>
        <ng-template #elseBlock>
          <a style="text-decoration: none;" [class]="activePage == page.item ? 'active' : ''">
            {{ page.name }}
          </a>
        </ng-template>
      </li>
    </ul>
  </div>
</div>
